export const connectionText = {
  disconnected: { text: "", type: "" },
  awaiting: { text: "Connecting", type: "text-success" },
  connected: { text: "Connected", type: "text-success" },
  failed: { text: "Failed", type: "text-danger" },
  lost: { text: "Connection lost", type: "text-danger" },
};
